export const vehicleShareLinkLimits = {
	maxListings: 50,
	maxMessageLength: 450,
	maxTitleLength: 100,
} as const
